import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { get, includes } from 'lodash'
import { plainToInstance } from 'class-transformer'
import useHelmApi from '@helm/composables/helmApi'
import { HELM_QUERY_KEYS } from '@helm/constants/query'
import MeResource from '@helm/services/api/transformers/MeResource'
import { HelmPermission } from '@helm/services/api/client'
import { TIME } from '@/constants/time'

const useMe = () => {
    const { api } = useHelmApi()

    const { data, isFetching, isSuccess } = useQuery({
        queryKey: HELM_QUERY_KEYS.me,
        queryFn: () => api.authentication.getLoggedInUser().then(({ data }) => data),
        select: data => plainToInstance(MeResource, data),
        staleTime: TIME.Hour(3)
    })

    const userId = computed(() => get(data.value, `id`, ``))
    const name = computed(() => get(data.value, `name`, ``))
    const nickname = computed(() => get(data.value, `nickname`, ``))
    const email = computed(() => get(data.value, `email`, ``))
    const avatar = computed(() => get(data.value, `avatar`, ``))
    const permissions = computed(() => get(data.value, `permissions`, []))

    const hasPermission = (permission: string) => {
        return includes(permissions.value, permission)
    }

    // Frequently used permission
    const canDebug = computed(() => hasPermission(HelmPermission.HELM_DEBUG))

    return {
        data,
        isFetching,
        isSuccess,
        name,
        nickname,
        email,
        userId,
        avatar,
        permissions,
        hasPermission,
        canDebug
    }
}

export default useMe
